module.exports = __webpack_public_path__ + "static/img/autumn_banner.3332f439.jpg";